var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvaluaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3332 8.33325V4.53325C11.3332 3.41315 11.3332 2.85309 11.1152 2.42527C10.9234 2.04895 10.6175 1.74299 10.2412 1.55124C9.81333 1.33325 9.25328 1.33325 8.13317 1.33325H3.8665C2.7464 1.33325 2.18635 1.33325 1.75852 1.55124C1.3822 1.74299 1.07624 2.04895 0.884491 2.42527C0.666504 2.85309 0.666504 3.41315 0.666504 4.53325V11.4666C0.666504 12.5867 0.666504 13.1467 0.884491 13.5746C1.07624 13.9509 1.3822 14.2569 1.75852 14.4486C2.18635 14.6666 2.7464 14.6666 3.8665 14.6666H5.99984M7.33317 7.33325H3.33317M4.6665 9.99992H3.33317M8.6665 4.66659H3.33317M7.6665 12.6666L8.99984 13.9999L11.9998 10.9999",
    stroke: "#4C60E5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluaIcon);
export default __webpack_public_path__ + "static/media/evalua_icon.96f5171911f5c21b515219aa8b900890.svg";
export { ForwardRef as ReactComponent };